import { useMsal } from '@azure/msal-react'
import { useEffect, useMemo } from 'react'
import { appInsights } from '../telemetry/appInsights'
const useIdentity = () => {
  const { accounts } = useMsal()

  const identity = useMemo(() => (Array.isArray(accounts) && accounts.length ? accounts[0] : undefined), [accounts])

  useEffect(() => {
    if (identity?.localAccountId) {
      appInsights.setAuthenticatedUserContext(identity.localAccountId)
    } else {
      appInsights.clearAuthenticatedUserContext()
    }
  }, [identity])

  return identity
}
export default useIdentity
